import { Icon } from "@chakra-ui/react";

export const ProfileIcon = (props) => (
  <Icon width="6" height="6" fill="none" {...props}>
    <path
      fill="#D11243"
      d="M11.77 2.16c-2.34 0-4.24 1.9-4.24 4.24 0 2.34 1.9 4.24 4.24 4.24 2.34 0 4.24-1.9 4.24-4.24 0-2.34-1.89-4.24-4.24-4.24Zm.14 7.21a3.16 3.16 0 0 1 0-6.32c1.74 0 3.16 1.42 3.16 3.16a3.16 3.16 0 0 1-3.16 3.16Z"
    />
    <path
      fill="#4B4F54"
      d="M12.26 12.61c6.28-.1 7.45 4.67 7.81 6.58.07.39.16.6.49.6.23 0 .41-.25.38-.53-.18-1.82-1.39-7.78-9.25-7.78-6.86 0-8.32 5.14-8.63 7.33-.07.51.25.97.68.97.75 0 1.22.54 1.11-.36-.29-2.53 1.29-6.72 7.41-6.81Z"
    />
    <path
      fill="#4B4F54"
      d="M3.26 19.55s1.81 2.29 8.91 2.29 8.65-2.16 8.65-2.16l-.53-1.07s-.99 2.09-8.25 2.13c-6.67.03-7.75-2.99-7.75-2.99l-1.03 1.8Z"
    />
  </Icon>
);
